<template>
  <div>
    <Navbar v-if="$route.meta.navbar"/>
    <!-- <Breadcrumb v-if="$route.meta.navbar" /> -->
    <div class="mt-3 pl-4">
      <h4>Export for Normvalues</h4>
      <p>
        Export survey data for normvalues calculation. The export includes all completed surveys
        (survey status = completed) with active membership status who are included in their survey.
      </p>
      <p>
        Each row represents one survey. The export contains the following columns:
      </p>
      <ul>
        <li><strong>id</strong> — Survey ID</li>
        <li><strong>Language</strong> — Survey language code</li>
        <li><strong>Normvalues</strong> — Normvalues country code</li>
        <li><strong>Survey end</strong> — Survey end date</li>
        <li><strong>Survey no. in group</strong> — Chronological position of the survey among the group's completed surveys, across both the legacy and current systems (all years)</li>
        <li><strong>Productivity</strong> — Average productivity score</li>
        <li><strong>Effectiveness</strong> — Average effectiveness score</li>
        <li><strong>Group age (months)</strong> — Average group age based on members' answers (numeric answers only)</li>
        <li><strong>Group members</strong> — Number of members in the survey's group</li>
        <li><strong>Stage</strong> — Determined GDQ stage (1–4): each scale's group average is checked against stage norms for the survey's normvalues country; the reported stage is the one where more than 2 of the 4 scale criteria are fulfilled (ties resolve to the highest stage; defaults to 1)</li>
        <li><strong>Q1–Q60</strong> — Per-question average answers</li>
        <li><strong>Survey Min/Max/Average/Span GDQ1–GDQ4</strong> — Per-scale min, max, average, and span of participant sums</li>
        <li><strong>Survey StageDiagSpan GDQ1–GDQ4</strong> — Per-scale stage diagnostic span</li>
      </ul>
      <label class="form-label mb-3" style="width: 180px;">
        <span style="margin-right: 8px;">Year:</span>
        <select class="form-select" style="display: inline-block; width: auto;" v-model="year">
          <option :value="null" disabled>Select</option>
          <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
        </select>
      </label>
      <button class="btn btn-primary" :disabled="!year || loading" @click.prevent="export_excel">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
        Download Excel
      </button>
      <div v-if="loading && progress" class="text-start mt-3" style="max-width: 480px;">
        <div class="progress" style="height: 20px;">
          <div class="progress-bar"
               :class="progress.status === 'error' ? 'bg-danger' : (isStalled ? 'bg-warning text-dark' : 'bg-primary')"
               role="progressbar"
               :style="{ width: progress.pct + '%' }"
               :aria-valuenow="progress.pct" aria-valuemin="0" aria-valuemax="100">
             {{ progress.pct }}%
          </div>
        </div>
        <small class="text-muted">{{ isStalled ? 'Still working — this can take a while.' : (progress.phase || 'Working…') }}</small>
      </div>
      <div v-if="error" class="alert alert-danger mt-3">{{ error }}</div>
    </div>
  </div>
</template>
<script>
import Navbar from "./Navbar.vue";
// import Breadcrumb from "./Breadcrumb";

export default {
  components: {
    Navbar,
    // Breadcrumb,
  },
  name: 'NormvaluesExport',
  data() {
    return {
      year: null,
      loading: false,
      error: null,
      jobId: null,
      progress: null,
      pollTimer: null,
      sawProgress: false
    }
  },
  computed: {
    years() {
      var currentYear = new Date().getFullYear();
      var result = [];
      result.push(2015);
      result.push(2016);
      for (var y = 2017; y <= currentYear; y++) {
        result.push(y);
      }
      return result;
    },
    isStalled() {
      return this.progress && this.progress.status === 'running' && this.progress.age_sec > 90;
    },
  },
  methods: {
    export_excel() {
      this.loading = true;
      this.error = null;
      this.progress = { status: 'running', phase: 'Starting', pct: 0, age_sec: 0 };
      this.sawProgress = false;
      this.jobId = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : Date.now() + '-' + Math.random().toString(36).slice(2);
      this.startPolling();
      this.$store.dispatch('normvalues_exportexcel', { year: this.year, job_id: this.jobId })
      .then((resp) => {
        var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        var filename = `normvalues_export_${this.year}`;
        fileLink.setAttribute("download", filename + ".xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      }).catch((err) => {
        var msg = "Export failed";
        if (err.response && err.response.data && err.response.data.error) {
          msg = err.response.data.error;
        } else if (err.response && err.response.status) {
          msg = msg + " (HTTP " + err.response.status + ")";
        } else if (err.message) {
          msg = msg + ": " + err.message;
        }
        this.error = msg;
      }).finally(() => {
        this.stopPolling();
        this.loading = false;
      });
    },
    startPolling() {
      this.stopPolling();
      this.pollOnce();
      this.pollTimer = setInterval(this.pollOnce, 1500);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    pollOnce() {
      if (!this.jobId) return;
      this.$store.dispatch('normvalues_progress', { job_id: this.jobId })
      .then((p) => {
        this.progress = p;
        this.sawProgress = true;
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 401) {
            this.stopPolling();
            this.loading = false;
            this.error = "Session expired — please sign in again.";
            return;
          }
          if (err.response.status === 404) {
            if (this.sawProgress) {
              // progress was found, now gone — job no longer valid
              this.stopPolling();
            }
            // no progress seen yet: startup window, keep polling
            return;
          }
        }
        return;
      });
    },
  },
  beforeUnmount() {
    this.stopPolling();
  }
}
</script>
<style scoped>
div {
  text-align: left;
}
</style>
